module.exports = require('./helpers/bundle-url').getBundleURL('iX4Xl') + "code-suggestions-spotlight.f7316a2b.png";